import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

/**
 * QA gate for the VIP confirmation modal. Stage-only flag with 0% rollout;
 * treatment is assigned via Amplitude testers (device/user IDs).
 */
export const useVipConfirmationExperiment = () =>
    useAmplitudeExperimentBase(AmplitudeExperiments.VipConfirmation, AmplitudeVariants.VipConfirmation.Treatment);
